import React from 'react';
import { Controller } from 'react-hook-form';
import { FormControl, FormHelperText } from '@mui/material';
import styles from './CustomSelect.module.css';

interface CustomSelectProps {
    name: string;
    control: any;
    label: string;
    options: Array<{ value: string | number; label: string }>;
    rules?: any;
    className?: string;
    onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
    name,
    control,
    label,
    options,
    rules,
    className = '',
    onChange
}) => {
    return (
        <>
            <label htmlFor={name} className="block text-gray-700 text-sm font-semibold mb-2">
                {label}
            </label>
            <FormControl fullWidth className={styles.formControl}>
                <Controller
                    name={name}
                    control={control}
                    rules={rules}
                    render={({ field, fieldState: { error } }) => (
                        <>
                            <select
                                {...field}
                                onChange={(e) => {
                                    field.onChange(e); // Update form state
                                    if (onChange) {
                                        onChange(e); // Call the custom onChange handler
                                    }
                                }}
                                className={`${styles.customSelect} ${error ? styles.error : ''}`}
                            >
                                {options.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            {error && (
                                <FormHelperText className={styles.formHelperText}>{error.message}</FormHelperText>
                            )}
                        </>
                    )}
                />
            </FormControl>
        </>
    );
};

export default CustomSelect;